/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useContext, useEffect, useState, useCallback } from 'react';
import _ from 'lodash';
import cx from 'classnames';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { useTranslator } from '@jutro/locale';
import { DateValue, formatCurrency, CurrencyValue, useModal } from '@jutro/components';
import { ViewModelServiceContext } from '@xengage/gw-portals-viewmodel-react';
import { AccountBillingDetailsService } from 'gw-capability-billing';
import { useDependencies } from '@xengage/gw-portals-dependency-react';
import { WizardContext } from '@xengage/gw-portals-wizard-react';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { MLProductCodeUtil } from 'ml-portals-util-js';
import { MLPolicyTypeUtil } from 'ml-portals-util-react';
import { MLModalService, MLTagManagerService } from 'ml-portals-services-react';
import { FormModalPopover, platformMessages } from 'ml-components-platform-react';
import { PolicyService } from 'gw-capability-gateway';
import { StateFeesComponent } from 'gw-capability-quoteandbind-common-react';
import { Contact } from 'gw-capability-quoteandbind';
import { MLFnolHelpBox } from 'gw-capability-fnol-common-react';

import MLNavigationStepsComponent from "./MLNavigationSteps/MLNavigationStepsComponent";
import styles from './AMPWizardSidebar.module.scss';
import messages from './AMPWizardSidebar.messages';

import { Button } from '@jutro/legacy/components';

import { IntlContext } from '@jutro/legacy/locale';

const STATUS_COMPLETE = 'complete';
const STATUS_ACTIVE = 'active';
const STATUS_PENDING = 'pending';

function AMPWizardSidebar(props) {
    const modalApi = useModal();
    const { EndorsementService } = useDependencies('EndorsementService');

    const {
        showProgressDialog
    } = MLModalService();

    const { authHeader } = useAuthentication();

    const [currentUser, setCurrentUser] = useState({});
    const wizardContext = useContext(WizardContext);
    const intl = useContext(IntlContext);
    const viewModelService = useContext(ViewModelServiceContext);
    const translator = useTranslator();
    const ModalService = MLModalService();
    const {
        steps, jumpTo, stepsWithErrors, wizardTitle, wizardData, currentStep, changeNextSteps, goNext, updateWizardData
    } = wizardContext;
    const [newWizardSteps, setNewWizardSteps] = useState([]);

    // For Policy Change, wizard data is a wrapper around subVM
    let submissionVM = wizardData;
    if (_.has(wizardData, 'submissionVM')) {
        submissionVM = wizardData.submissionVM;
    }

    const { history, location } = props;
    const jobType = _.get(submissionVM, 'baseData.jobType.value.code');
    const [producerCodeOfRecord, setProducerCodeOfRecord] = useState({});
    const [producerName, setProducerName] = useState('');
    const { getPolicyTypeName } = MLPolicyTypeUtil();

    // Cancellation stuff
    const isCancellation = wizardData.isCancellation;
    const [policyPeriod, setPolicyPeriod] = useState();
    const [namedInsured, setNamedInsured] = useState();
    const [policyLabel, setPolicyLabel] = useState();

    // ML
    const isPolicyChangeML = jobType === 'PolicyChange' || isCancellation;

    // Confirmation Variables
    const [insured, setInsured] = useState();
    const [insuredContact, setInsuredContact] = useState();
    const [insuredFullName, setInsuredFullName] = useState();
    const [secondaryInsuredName, setSecondaryInsuredName] = useState();
    const [paymentMethod, setPaymentMethod] = useState();
    const [last4Digits_ML, setLast4Digits_ML] = useState();
    const [paymentSchedule, setPaymentSchedule] = useState();
    const [transactionAmount, setTransactionAmount] = useState();
    const [showMakePaymentButton, setShowMakePaymentButton] = useState();
    const last4DigitsArray = ['credit_debit_card', 'bank_account'];
    const ratingPaymentMethodTypelist = viewModelService.productMetadata.get('pc').types.getTypelist('RatingPaymentMethod_ML');

    // FNOL stuff
    const isFNOL = location.pathname.startsWith("/fnol");

    const getPolicyLabel = () => {
        let policyTypeName;
        const productCode = _.get(submissionVM, 'baseData.productCode.value');
        if (MLProductCodeUtil.isHomeOwners(productCode)) {
            policyTypeName = getPolicyTypeName(_.get(submissionVM, 'lobData.homeowners.coverables.coveragePartType_ML.value.code'), translator);
        } else {
            policyTypeName = getPolicyTypeName(productCode, translator);
        }
        return translator(messages.yourPolicy, { policyType: policyTypeName });
    };

    const onEditEffectiveDateClick = () => {
        const index = _.findIndex(steps, ({path}) => path === '/policychange');
        jumpTo(index);
    }

    const isProducerContactDefined = () => {
        return !_.isNil(producerCodeOfRecord.producerContactFirstName_ML) && !_.isNil(producerCodeOfRecord.producerContactLastName_ML);
    };

    const getProducerNameToDisplay = () => {
        if (isProducerContactDefined()) {
            return `${producerCodeOfRecord.producerContactLastName_ML}, ${producerCodeOfRecord.producerContactFirstName_ML}`;
        }
        return producerCodeOfRecord.group_ML.name;
    };

    const setProducerInfo = () => {
        setProducerCodeOfRecord(_.get(submissionVM, 'producerCodeOfRecord_ML.value', 
            currentUser.producerCodes_ML.find((producerCode) => producerCode.code === submissionVM.baseData.producerCode_ML.value)
        ));
    };

    const getPolicyPeriod = () => {
        const promise = PolicyService.getLatestPolicyPeriodForPolicy(submissionVM.policy.policyNumber.value, authHeader);
        showProgressDialog(platformMessages.loading, promise, true);
        promise.then((pol) => {
            setPolicyPeriod(pol);
        });
    }

    useEffect(() => {
        if (!_.isEmpty(producerCodeOfRecord)) {
            setProducerName(getProducerNameToDisplay());
        }  
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [producerCodeOfRecord])

    useEffect(() => {
        if (!_.isEmpty(currentUser)) {
            setProducerInfo();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentUser])

    useEffect(() => {
        if(isCancellation && !policyPeriod){
            getPolicyPeriod();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (isCancellation && policyPeriod){
            if(!namedInsured){
                setNamedInsured(policyPeriod.namedInsureds_ML.find((ins) => ins.isPrimaryNamedInsured_ML));
            }
            if(!policyLabel){
                setPolicyLabel(translator(messages.cancellationTypePolicy, {policyType: getPolicyTypeName(policyPeriod.policyProductCode_ML)}))
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [policyPeriod]);

    useEffect(() => {
        
        const currentStepIndex = _.findIndex(steps, (step) => step.id === currentStep.id);

        steps.forEach((step, index) => {
            if (index < currentStepIndex) {
                step.status = STATUS_COMPLETE;
            } else if (index === currentStepIndex) {
                step.status = STATUS_ACTIVE;
            } else {
                step.status = STATUS_PENDING;
            }
        });

        const visibleSteps = steps.filter((step) => !step.stepHidden);

        let prevIndex = 0;
        const mappedSteps = visibleSteps.reduce((reduced, item) => {
            if (item.groupName) {
                if (reduced.length === 0 || item.groupName !== reduced[prevIndex].group) {
                    reduced.push({
                        group: item.groupName,
                        steps: [],
                    });
                    prevIndex = reduced.length - 1;
                }

                reduced[prevIndex].steps.push(item)
            } else {
                reduced.push({
                    group: '',
                    step: item
                });
                prevIndex = reduced.length - 1;
            }
            return reduced;
        }, []);

        mappedSteps.forEach((mappedStep) => {
            if (mappedStep.group) {
                mappedStep.isOpen = mappedStep.steps.some((s) => s.status === STATUS_ACTIVE);

                mappedStep.status = STATUS_PENDING;
                if (mappedStep.isOpen) {
                    mappedStep.status = STATUS_ACTIVE;
                } else if (mappedStep.steps[mappedStep.steps.length - 1].status === STATUS_COMPLETE) {
                    mappedStep.status = STATUS_COMPLETE;
                }
            }
        });
        setNewWizardSteps(mappedSteps);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const onConfirmationScreen = () => {
        return currentStep.mlStepName === 'endorsementConfirmation';
    };

    const onDisclosuresScreen = () => {
        return currentStep.mlStepName === 'endorsementPaDisclosures' || currentStep.mlStepName === 'endorsementPupDisclosures'
    };

    const goToQuoteDetails = () => {
        const index = _.findIndex(steps, ({mlStepName}) => mlStepName === 'endorsementQuoteDetails');
        if(index > -1){
            jumpTo(index);
        }
    }

    useEffect(() => {
        if (onConfirmationScreen()) {
            setInsured(submissionVM.baseData.policyContact_ML.value);
            const newInsuredContact = new Contact(submissionVM.baseData.policyContact_ML.value);
            const nameSuffixTypeList = viewModelService.productMetadata.get('pc').types.getTypelist('NameSuffix');
            setInsuredContact(newInsuredContact);
            setInsuredFullName(newInsuredContact.getFullName(nameSuffixTypeList, translator));
            setSecondaryInsuredName(submissionVM.baseData.secondaryInsuredFullName_ML.value);
            const paymentMethodType = ratingPaymentMethodTypelist.getCode(submissionVM.value.paymentDetails_ML.ratingPaymentMethod_ML);
            const translatedPaymentMethod = translator({id: paymentMethodType.name, defaultMessage: paymentMethodType.name})
            setPaymentMethod(translatedPaymentMethod);
            setLast4Digits_ML(submissionVM.value.paymentDetails_ML.last4Digits_ML);
            const selectedPaymentPlan = submissionVM.value.paymentDetails_ML.paymentPlans_ML.find((plan) => {
                return plan.billingId === submissionVM.value.paymentDetails_ML.selectedPaymentPlan;
            });
            setPaymentSchedule(selectedPaymentPlan ? selectedPaymentPlan.name : '');
            setTransactionAmount(submissionVM.transactionCost.value);

            const billingPromise = AccountBillingDetailsService.getPolicyTermBillingSummary(submissionVM.value.policyNumber, submissionVM.value.periodTermNumber_ML, authHeader);
            billingPromise.then((data) => {
                setShowMakePaymentButton(_.get(data, 'paymentDueAmount_ML.amount', 0) > 0);
            }).catch((error) => { console.error(error) });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const withdraw = useCallback(async () => {
        const withdrawAndGoPoliciesPage = () => {
            MLTagManagerService.sendLinkClickEvent('Discard All Changes');
            const withdrawPromise = EndorsementService.withdrawEndorsement([submissionVM.value.jobID], authHeader);
            showProgressDialog(messages.withdrawingPolicyChange, withdrawPromise);

            _.set(wizardData, 'submissionVM.value.withdrawPolicyChange', true);
            updateWizardData(wizardData);

            history.push('/policies');
        };

        const componentProps = {
            title: translator(messages.confirmationTitle),
            actionBtnLabel: messages.yes,
            cancelBtnLabel: messages.cancel,
            simpleMessage: translator(messages.confirmationDesc),
            closeSimpleMessage: false
        };
    
        modalApi.showModal(
            <FormModalPopover {...componentProps} />
        ).then(withdrawAndGoPoliciesPage);
    }, [EndorsementService, authHeader, history, showProgressDialog, submissionVM.value.jobID, translator]);

    const getFormatCurrency = (value) => {
        let formattedAmount = '';
        if (value) {
            const { amount, currency } = value;
            if (!_.isUndefined(amount) && currency) {
                formattedAmount = intl.formatNumber(
                    amount,
                    {
                        style: 'currency',
                        currency: currency
                    }
                );
            }
        }
        return formattedAmount;
    };

    const showEndingInLast4 = (paymentMethodCode) => {
        return last4DigitsArray.includes(paymentMethodCode);
    };

    const makePayment = () => {
        history.push('/make-payment');
    };

    const getEndorsementSidebar = () => {
        return (
            <div className={styles.ampWizardSidebar}>
                <header className="qb-right-rail__header">
                    {getPolicyLabel()}
                </header>

                <section className="qb-right-rail__section">
                    <header>
                        {translator(messages.policyDetailsTitle)}
                    </header>
                    <p className="font-weight-bold">{translator(messages.policyNumber, { policyNumber: submissionVM.policyNumber.value })} </p>
                    <p>{translator(messages.effectiveDateOfChange)}
                        <DateValue displayFormat='vshort' value={_.get(submissionVM, 'baseData.effectiveDate.value')} tag="span" />
                    </p>
                    {onConfirmationScreen() && (
                        <span>
                            
                            <p>{translator(messages.amountOfChange)}
                                {getFormatCurrency(transactionAmount)}
                            </p>
                        </span>
                    )}
                    {!onConfirmationScreen() && (
                        <span>
                            <div>
                                <a className="text-link" onClick={onEditEffectiveDateClick}>
                                    {translator(messages.editEffectiveDate)}
                                </a>
                            </div>
                        </span>
                    )}
                </section>
                {!onConfirmationScreen() &&  (
                    <div>
                        <section className="qb-right-rail__section">
                            <header>
                                {translator(messages.changeProgressBar)}
                            </header>
                            <div role="navigation" aria-label={translator(wizardTitle)}>
                                {isPolicyChangeML && <MLNavigationStepsComponent currentStep={currentStep} changeNextSteps={changeNextSteps} goNext={goNext} endorsementVM={submissionVM} steps={steps} />}
                            </div>
                        </section>
                        {_.get(submissionVM, 'jobID.value', false) && (
                            <section className="qb-right-rail__section">
                                <Button type="outlined" onClick={withdraw}>
                                    {translator(messages.discardAllChanges)}
                                </Button>
                            </section>
                        )}
                    </div>
                )}
                {onConfirmationScreen() && (
                    <>
                        <section className="qb-right-rail__section">
                            <div className="qb-right-rail__flex-row">
                                <p className="font-weight-bold"><strong>{translator(messages.paymentMethod)}</strong></p>
                                <p>
                                    <span className="display-block">{paymentMethod}</span>
                                    {showEndingInLast4(submissionVM.value.paymentDetails_ML.ratingPaymentMethod_ML) && 
                                    <span>
                                        {translator(messages.paymentMethodEndingIn, {last4Digits: last4Digits_ML})}
                                    </span>}
                                </p>
                            </div>
                            <div className="qb-right-rail__flex-row">
                                <p className="font-weight-bold">{translator(messages.paymentSchedule)}</p>
                                <p>{paymentSchedule}</p>
                            </div>
                        </section>
                        <section className="qb-right-rail__section">
                            <header>
                                {translator(messages.insured)}
                            </header>
                            <p className="font-weight-bold">{insuredFullName}</p>
                            <p>{_.get(insured, 'primaryAddress.addressLine1', '')}</p>
                            {insured && <p>{insured.primaryAddress.city}, {insured.primaryAddress.state} {insured.primaryAddress.postalCode}</p>}

                            {secondaryInsuredName && <header>
                                {translator(messages.coInsured)}
                            </header>}
                            {secondaryInsuredName && <p className="font-weight-bold">{ secondaryInsuredName }</p>}
                        </section>
                        {showMakePaymentButton && <section className="qb-right-rail__section">
                            <Button type="outlined" onClick={makePayment}>
                                {translator(messages.makeAPayment)}
                            </Button>
                        </section>}
                    </>
                )}
            </div>
        );
    }

    const getEndorsementDisclosuresSidebar = () => {
        const isPersonalAuto = submissionVM.value.isPersonalAuto();
        const isPersonalUmbrella = submissionVM.value.isPersonalUmbrella();
        const numMonthsInTerm = submissionVM.baseData.termType_ML.value === 'Annual' ? 12 : 6;
        const previousTotalCost = submissionVM.previousTotalCost.value.amount;
        const previousMonthlyCost = previousTotalCost / numMonthsInTerm;
        const currentTotalCost = submissionVM.totalCost.value.amount;
        const currentMonthlyCost = currentTotalCost / numMonthsInTerm;
        return(<>
            {isPersonalAuto && 
                <p className= "vertical-spacing-10 body-copy font-weight-bold">
                    {translator(messages.autoInsurance)}
                </p>
            }
            {isPersonalUmbrella && 
                <p className= "vertical-spacing-10 body-copy font-weight-bold">
                    {translator(messages.umbrellaInsurance)}
                </p>
            }
            <div className= "qb-right-rail__section">
                <h2 className="section-header display-inline-block">
                    <CurrencyValue amount={currentMonthlyCost} currency="USD" tag="span" showFractions/>
                </h2>
                <p className="body-copy font-weight-bold secondary display-inline">
                    {`/${translator(messages.month)}`}
                </p>
                <p className="body-copy dark-gray">
                    {`${translator(messages.previousCost)} `}
                    <CurrencyValue amount={previousMonthlyCost} currency="USD" tag="span" showFractions/>
                    {` /${translator(messages.month)}`}
                </p>
                <p className="body-copy secondary font-weight-bold">
                    {translator(messages.or)}
                </p>
                <h2 className="section-header display-inline-block">
                    <CurrencyValue amount={currentTotalCost} currency="USD" tag="span" showFractions/>
                </h2>
                <p className="body-copy font-weight-bold secondary display-inline">
                    {`/${translator(messages.year)}`}
                </p>
                <p className="body-copy dark-gray">
                    {`${translator(messages.previousCost)} `}
                    <CurrencyValue amount={previousTotalCost} currency="USD" tag="span" showFractions/>
                    {` /${translator(messages.year)}`}
                </p>
                {_.get(submissionVM, 'totalChanges_Ext.value.amount', 0) !== 0 &&
                    <StateFeesComponent 
                        totalFees={_.get(submissionVM, 'totalChanges_Ext.value')}
                        itemizedFees={_.get(submissionVM, 'feesCosts_Ext.value', [])}
                        displayAlternativeTemplate
                        translator={translator}
                    />
                }
            </div>
        </>)
    }

    const getFNOLSteps = () => {
        const currentStepIndex = _.findIndex(steps, (step) => step.id === currentStep.id);
        steps.forEach((step, index) => {
            if (index < currentStepIndex) {
                step.status = STATUS_COMPLETE;
            } else if (index === currentStepIndex) {
                step.status = STATUS_ACTIVE;
            } else {
                step.status = STATUS_PENDING;
            }
        });
        const visibleSteps = steps.filter((step) => !step.stepHidden);
        
        const jumpToStep = (step) => {
            const index = _.findIndex(steps, (_step) => _step === step);
            if(index > -1){
                jumpTo(index);
            }
        }

        const jumpToPolicySelectStep = () => {
            // Placeholder for now (in v9 it doesn't seem to be doing anything)
        }

        return <>
            <li onClick={() => jumpToPolicySelectStep()}>
                {translator(messages.StartAClaim)}
            </li>
            { visibleSteps.map((step) => 
                <li key={`FNOLVisibleStep${step.id}`} className={['pending', 'active'].includes(step.status) ? 'pending-icon' : undefined} onClick={() => jumpToStep(step)}>
                    {translator(step.title)}
                </li>
            )}
        </>
    }

    const getFNOLSidebar = () => {
        return (
            <>
                <div className="qb-right-rail__header">
                    {translator(messages.YourClaim)}
                </div>
                <div className={cx("qb-right-rail__section", styles.fnolRightRailIconColors)}>
                    <ul className="styled-ul-list check-icon blue-icon vertical-spacing-0">
                        {getFNOLSteps()}
                    </ul>
                </div>
            </>
        );
    }

    return (
        <>
            { !isFNOL  &&
                <div className={`qb-right-rail${isPolicyChangeML && onDisclosuresScreen() ? " vertical-spacing-40" : ""}`}>
                    {isPolicyChangeML && getEndorsementSidebar()}
                </div>
            }
            { isFNOL && currentStep.id !== 'policySelect' && 
                <div className="qb-right-rail vertical-spacing-20">
                    {isFNOL && getFNOLSidebar()}
                </div>
            }
            {isPolicyChangeML && onDisclosuresScreen() && 
                <>
                    <div className="qb-right-rail vertical-spacing-20">
                        {getEndorsementDisclosuresSidebar()}
                    </div>
                    <div className="row clearfix">
                        <div className="col-sm-12 text-align-center">
                            <a onClick={goToQuoteDetails}>
                                {translator(messages.reviewYourCoverages)}
                            </a>
                        </div>
                    </div>
                </>
            }
            { isFNOL && 
                <MLFnolHelpBox currentStep={currentStep}/>
            }
        </>
    );
}

AMPWizardSidebar.propTypes = {
    customMessageModal: PropTypes.shape({})
};
AMPWizardSidebar.defaultProps = {
    customMessageModal: {}
};
export default withRouter(AMPWizardSidebar);
